/* assets/wwm-upsell.js — "Buy Together" upsell row. Host-agnostic core + adapters for the
   PDP Customizer (reads items via wwmUpsell.items) and the main PDP product form. */
(function () {
  if (window.wwmUpsell) return;
  var SOURCE = { customizer: 'PDP Customizer', product: 'PDP Upsell' };

  /* Checked, purchasable cards → /cart/add.js items */
  function items(root) {
    return [].slice.call(root.querySelectorAll('[data-wwm-ups-card]:not([hidden])')).filter(function (c) {
      return c.querySelector('[data-wwm-ups-check]').checked && c.dataset.variantId;
    }).map(function (c) {
      return { id: Number(c.dataset.variantId), quantity: 1, properties: { _source: SOURCE[root.dataset.wwmUpsHost] || 'PDP Upsell' } };
    });
  }

  /* Money formatting from the shop's money_format ("${{amount}}" etc.) */
  function money(cents, format) {
    var n = cents / 100;
    var out = format.indexOf('no_decimals') > -1 ? Math.round(n).toLocaleString() : n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out);
  }

  /* Bundle discount display: price reduced by data-wwm-ups-discount %, original struck through */
  function applyDiscount(root, card) {
    var pct = Number(root.dataset.wwmUpsDiscount) || 0;
    var chosen = Number(card.dataset.wwmUpsCents);
    var price = chosen || Number(card.dataset.wwmUpsInitialCents);
    var compare = chosen ? Number(card.dataset.wwmUpsCompareCents) : Number(card.dataset.wwmUpsInitialCompareCents);
    if (!pct || !price) return;
    var was = Math.max(price, compare || 0);
    var now = card.querySelector('[data-wwm-ups-price]'), old = card.querySelector('[data-wwm-ups-compare]');
    now.textContent = money(Math.round(price * (100 - pct) / 100), root.dataset.wwmUpsMoney);
    now.classList.add('is-sale');
    old.textContent = money(was, root.dataset.wwmUpsMoney);
    old.hidden = false;
  }

  /* Arrows: hide prev at the start and next at the end. One passive scroll listener per track,
     debounced so nothing runs per pixel — the buttons update ~150ms after scrolling stops. */
  function updateArrows(root) {
    var track = root.querySelector('[data-wwm-ups-track]'), prev = root.querySelector('[data-wwm-ups-prev]'), next = root.querySelector('[data-wwm-ups-next]');
    if (!prev) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.hidden = track.scrollLeft <= 1;
    next.hidden = track.scrollLeft >= max - 1;
  }
  function watchArrows(root) {
    var track = root.querySelector('[data-wwm-ups-track]');
    if (track.dataset.wwmUpsWatched) return;
    track.dataset.wwmUpsWatched = '1';
    var timer;
    var later = function () { clearTimeout(timer); timer = setTimeout(function () { updateArrows(root); }, 150); };
    track.addEventListener('scroll', later, { passive: true });
    window.addEventListener('resize', later);
  }

  /* Hide excluded products (dedupe), apply the discount display, hide the whole row when nothing is left */
  function refresh(root) {
    var exclude = (root.dataset.wwmUpsExclude || '').split(',');
    var visible = 0;
    root.querySelectorAll('[data-wwm-ups-card]').forEach(function (c) {
      var off = root.dataset.wwmUpsDedupe === 'true' && exclude.indexOf(c.dataset.productId) > -1;
      c.hidden = off;
      if (off) { c.querySelector('[data-wwm-ups-check]').checked = false; c.classList.remove('is-selected'); }
      else { visible++; applyDiscount(root, c); }
    });
    root.hidden = !visible;
    watchArrows(root);
    updateArrows(root);
  }

  function setExclude(root, ids) {
    root.dataset.wwmUpsExclude = ids.filter(Boolean).join(',');
    refresh(root);
  }

  /* Complementary source: fetch cards for a product and swap them in */
  function load(root, productId) {
    if (!root.dataset.recsUrl || !productId) return Promise.resolve();
    return fetch(root.dataset.recsUrl + '&product_id=' + productId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var cards = tmp.querySelector('[data-wwm-ups-cards]');
        root.querySelector('[data-wwm-ups-track]').innerHTML = cards ? cards.innerHTML : '';
        refresh(root);
      })
      .catch(function () { root.hidden = true; });
  }

  /* Card interactions: checkbox + variant select */
  document.addEventListener('change', function (e) {
    var card = e.target.closest('[data-wwm-ups-card]');
    if (!card) return;
    var check = card.querySelector('[data-wwm-ups-check]');
    var select = e.target.closest('[data-wwm-ups-select]');
    if (select) {
      var o = select.options[select.selectedIndex];
      card.dataset.variantId = o.value;
      card.dataset.wwmUpsCents = o.dataset.cents;
      card.dataset.wwmUpsCompareCents = o.dataset.compareCents || 0;
      var now = card.querySelector('[data-wwm-ups-price]'), was = card.querySelector('[data-wwm-ups-compare]');
      now.textContent = o.dataset.priceText;
      now.classList.toggle('is-sale', !!o.dataset.compareText);
      was.textContent = o.dataset.compareText || '';
      was.hidden = !o.dataset.compareText;
      var img = card.querySelector('.wwm-ups__media img');
      if (img && o.dataset.image) { img.removeAttribute('srcset'); img.src = o.dataset.image; }
      if (o.value) check.checked = true;
      applyDiscount(card.closest('[data-wwm-upsell]'), card);
    }
    /* Checking a card that still needs an option: stay unchecked and open the dropdown.
       Picking an option checks it (above); closing the dropdown without picking leaves it unchecked. */
    if (!select && check.checked && !card.dataset.variantId) {
      check.checked = false;
      var picker = card.querySelector('[data-wwm-ups-select]');
      try { picker.showPicker(); } catch (err) { picker.focus(); }
    }
    card.classList.toggle('is-selected', check.checked);
  });

  /* Whole card toggles the checkbox (the checkbox label and the dropdown handle themselves;
     image/title links stay links unless "Disable links" is on). */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-wwm-ups-card]');
    if (!card || e.target.closest('.wwm-ups__check, .wwm-ups__select-wrap')) return;
    var link = e.target.closest('.wwm-ups__media, .wwm-ups__title');
    if (link && card.closest('[data-wwm-upsell]').dataset.wwmUpsLinks !== 'true') return;
    e.preventDefault();
    var check = card.querySelector('[data-wwm-ups-check]');
    check.checked = !check.checked;
    check.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Arrows */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wwm-ups-prev], [data-wwm-ups-next]');
    if (!btn) return;
    var track = btn.closest('.wwm-ups__viewport').querySelector('[data-wwm-ups-track]');
    var card = track.querySelector('[data-wwm-ups-card]:not([hidden])');
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var w = card ? card.getBoundingClientRect().width + gap : 240;
    track.scrollBy({ left: btn.hasAttribute('data-wwm-ups-next') ? w : -w, behavior: 'smooth' });
  });

  /* Shared add: upsells first so the main item lands on top of the cart drawer */
  function addToCart(mainItems, upsellItems) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: upsellItems.concat(mainItems) })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  /* Keep the theme's quick-cart ordering in sync (theme.js sorts by fluco_cart_order) */
  function rememberOrder(ids) {
    try {
      var key = 'fluco_cart_order';
      var order = JSON.parse(localStorage.getItem(key)) || [];
      localStorage.setItem(key, JSON.stringify(ids.concat(order.filter(function (i) { return ids.indexOf(i) < 0; }))));
    } catch (err) {}
  }

  /* Refresh the quick cart, then open it once the new markup has landed (mirrors the theme's own
     "update, then open" order). Opening first lets the refresh wipe the cart-upsells modal and skip
     the footer padding pass, which is what made the drawer flaky and un-scrollable on mobile. */
  function openCart() {
    var drawer = document.querySelector('.quick-cart'), icon = document.querySelector('[data-js-cart-icon]');
    var done = false, timer, observer;
    var open = function () {
      if (done) return;
      done = true;
      clearTimeout(timer);
      if (observer) observer.disconnect();
      if (icon) icon.click();
    };
    if (drawer) {
      observer = new MutationObserver(function () { setTimeout(open, 50); });
      observer.observe(drawer, { childList: true, subtree: true });
    }
    timer = setTimeout(open, 1500);
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
  }

  /* Main PDP adapter: intercept the theme's product form only when an upsell is checked */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    var section = form.closest('[data-section-type="product"]');
    var root = section && section.querySelector('[data-wwm-upsell][data-wwm-ups-host="product"]');
    if (!root) return;
    var extras = items(root);
    if (!extras.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    var fd = new FormData(form);
    var main = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1), properties: {} };
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') main.properties[m[1]] = v;
    });
    if (fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));
    if (!Object.keys(main.properties).length) delete main.properties;

    var buttons = form.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(function (b) { b.classList.add('loading'); });
    var finish = function (res, added) {
      rememberOrder(added.map(function (i) { return i.id; }));
      /* Parity with the theme's own add path for anything listening (GTM etc.) */
      (res.items || [res]).forEach(function (item) { document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: item } })); });
      buttons.forEach(function (b) { b.classList.remove('loading'); });
      openCart();
    };
    addToCart([main], extras)
      .then(function (res) { finish(res, [main].concat(extras)); })
      /* /cart/add.js is all-or-nothing: if an upsell went out of stock, still add the main product */
      .catch(function () { return addToCart([main], []).then(function (res) { finish(res, [main]); }); })
      .catch(function () { buttons.forEach(function (b) { b.classList.remove('loading'); }); });
  }, true);

  /* Init: complementary rows on the product host fetch for the page's product */
  function init() {
    document.querySelectorAll('[data-wwm-upsell]').forEach(function (root) {
      refresh(root);
      if (root.dataset.wwmUpsHost === 'product' && root.dataset.recsProduct) load(root, root.dataset.recsProduct);
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);

  window.wwmUpsell = { items: items, refresh: refresh, setExclude: setExclude, load: load, addToCart: addToCart, rememberOrder: rememberOrder, openCart: openCart };
})();
